const config = require("config");
const eventTracker = require("../alk-engagement/eventTracker");
eventTracker.init(config, require("appboy-web-sdk"));
(function() {

    var id = "reportApp";

    var app = angular.module(id, [
        // Angular modules
        "ui.bootstrap",
        "pcmCommon",
        "copyright.text",
        "alk.authentication",
        "alk.services",
        "alk.constants",
        "alk.modal",
        "alk.translations",
        "alk.maps",
        // Custom modules

        // 3rd Party Modules

    ]);

    app.constant("ALKMaps", window.ALKMaps); // TODO
    app.constant("_", require("lodash"));
    app.constant("moment", window.moment);
    app.constant("eventTracker", eventTracker);

    app.config(function() {
      //Setup track.js
      if (config.trackJsEnvironment && typeof trackJs !== "undefined") {
        //console.log("Setting up trackjs for application \"" + config.trackJsEnvironment + "\"");
        trackJs.configure({
          application: config.trackJsEnvironment
        });
      }
    });
})();



// WEBPACK FOOTER //
// ./app/report/reportApp.js